<template>
  <base-modal-bottom
    ref="basePhoneModal"
    class="has-text-centered"
    :isFooter="true"
    :title="title"
  >
    <template #btn-close-icon>
      <div class="button-close-custom" @click="closeModal()">
        <base-icon
          style="margin: 0 auto"
          width="16"
          height="16"
          name="painel/close-icon"
        />
      </div>
    </template>

    <div class="c-modal-phone">
      <div class="margin-bottom">
        <base-icon width="90" height="115" :name="icon" />
      </div>

      <p class="margin-bottom c-modal-phone--max-width c-modal-phone--title">
        <strong>Mais segurança para suas transações</strong>
      </p>

      <p class="margin-bottom c-modal-phone--max-width c-modal-phone--info">
        Para realizar essa alteração entre em contato com o nosso atendimento
        pelo <span class="is-primary">chat</span>.
      </p>
    </div>
    <template #footer>
      <div class="footer-modal-sms">
        <div class="c-modal-phone__btn-footer">
          <base-button-bottom
            @click.native="closeModal()"
            class="is-primary is-big"
            type="button"
          >
            Ok, entendi
          </base-button-bottom>
        </div>
      </div>
    </template>
  </base-modal-bottom>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'
import SimpleVueValidator from 'simple-vue-validator'

export default {
  mixins: [SimpleVueValidator.mixin],

  props: {
    title: {
      type: String,
      default: 'Verificação de Segurança',
    },
    icon: {
      type: String,
      default: 'account-shield',
    },
  },

  components: {
    BaseModalBottom,
    BaseButtonBottom,
  },

  mounted() {
    this.open()
  },

  methods: {
    open() {
      this.$refs.basePhoneModal.open()
    },

    closeModal() {
      this.$refs.basePhoneModal.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-modal__body {
  padding: 32px 16px 8px !important;
}

.c-base-button-bottom {
  position: relative;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}

.c-modal-phone {
  &--max-width {
    max-width: 400px;
    margin: 0 auto;
    padding-bottom: 12px;
  }

  &--exemplo {
    font-size: 12px;
  }

  &--title {
    font-size: 18px;
  }

  &--info {
    font-size: 16px;

    span {
      color: $primary;
      font-weight: bold;
    }
  }

  &__input-cod {
    display: flex;
    justify-content: center;

    &--input {
      border: 0.0625rem solid $gray-4;
      border-radius: 4px;
      margin: 5px;
      padding: 0;
      text-align: center;
      width: 40px;
      height: 40px;
    }
  }

  &__btn-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &--submit {
      margin-bottom: 16px;
    }

    &--send-cod {
      background-color: $gray-5 !important;
    }

    &--change-number {
      margin-top: 16px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.07;
      letter-spacing: normal;
      color: $support;
      cursor: pointer;
    }
  }
}

.field-body {
  margin-top: 20px;
}

.button-close-custom {
  width: 40px;
}
</style>
